import { c as _c } from "react/compiler-runtime";
import { graphql, useQuery } from "@opensea/graphql";
import { ActionTimelineFragment } from "../../../../components/ActionTimeline/ActionTimeline.fragment";
import { NETWORK_ONLY_OPERATION_CONTEXT } from "../../../../constants";
import { useAccount } from "../../../../polychain/hooks/useAccount";
import { useSetBlockchainActionErrors } from "../../../hooks/useSetBlockchainActionErrors";
import { useSetBlockchainActionErrorsFragment } from "../../../hooks/useSetBlockchainActionErrors.fragment";
const AcceptOfferQuery = graphql(`
    query AcceptOfferQuery(
      $address: Address!
      $itemQuantities: [ItemQuantityInput!]!
      $applyOptionalCreatorFees: Boolean
    ) {
      acceptOffers(
        address: $address
        itemQuantities: $itemQuantities
        applyOptionalCreatorFees: $applyOptionalCreatorFees
      ) {
        actions {
          ...ActionTimeline
        }
        errors {
          ...useSetBlockchainActionErrors
        }
      }
    }
  `, [ActionTimelineFragment, useSetBlockchainActionErrorsFragment]);
export const useAcceptOfferQuery = params => {
  const $ = _c(16);
  const {
    itemQuantities,
    pause,
    applyOptionalCreatorFees
  } = params;
  const {
    address
  } = useAccount();
  const t0 = address;
  let t1;
  if ($[0] !== applyOptionalCreatorFees || $[1] !== itemQuantities || $[2] !== t0) {
    t1 = {
      address: t0,
      itemQuantities,
      applyOptionalCreatorFees
    };
    $[0] = applyOptionalCreatorFees;
    $[1] = itemQuantities;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = !address || pause;
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = {
      query: AcceptOfferQuery,
      variables: t1,
      pause: t2,
      context: NETWORK_ONLY_OPERATION_CONTEXT
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const [t4, refetch] = useQuery(t3);
  const {
    data,
    error,
    fetching
  } = t4;
  let t5;
  if ($[7] !== data?.acceptOffers.actions) {
    t5 = data?.acceptOffers.actions ?? [];
    $[7] = data?.acceptOffers.actions;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const actions = t5;
  useSetBlockchainActionErrors(data?.acceptOffers.errors);
  let t6;
  if ($[9] !== refetch) {
    t6 = () => refetch({
      requestPolicy: "network-only"
    });
    $[9] = refetch;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== actions || $[12] !== error || $[13] !== fetching || $[14] !== t6) {
    t7 = {
      actions,
      error,
      fetching,
      refetch: t6
    };
    $[11] = actions;
    $[12] = error;
    $[13] = fetching;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};